import { PageWrapper } from '@qonsoll/react-design'

const GDPRPage = () => (
  <PageWrapper
    headingProps={{
      title: 'Cookie Policy'
    }}>
    You agreed with Cookie Policy
  </PageWrapper>
)

export default GDPRPage
